import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { LocalStorage } from 'ngx-store';
import { Customer } from 'src/app/model/customer.model';
import { Page } from 'src/app/model/pagination';
import { Url } from 'src/app/model/users.model';
import { RequestPayload, ReturnMessage, TransvirtualAccount } from './transvirtual';

@Injectable({
  providedIn: 'root'
})
export class TransvirtualService {
  @LocalStorage() private url: Url;

  /**
  * HTTP entry route to do Transvirtual-related operations.
  */
  private transvirtualRoute: string;
  private transvirtualLogRoute: string;
  private customerRoute: string;


  constructor(private client: HttpClient) {
    this.transvirtualRoute = `${this.url.rest}/api/transvirtual/accounts`;
    this.transvirtualLogRoute = `${this.url.rest}/api/transvirtual/logs`;
    this.customerRoute = `${this.url.rest}/tms/getCustomers`;
  }


  public getAccounts() {

    let queryParams = new HttpParams()
      .set('fields[customer]', 'id,company_name')
      .set('include', 'customer')

    return this.client
      .get<Page<TransvirtualAccount>>(`${this.transvirtualRoute}`, { params: queryParams })
  }

  public getCustomerSelection() {
    return this.client
      .get<{ customers: Customer[] }>(`${this.customerRoute}`)
  }

  public saveAccounts(payload: RequestPayload) {
    return this.client
      .post<ReturnMessage>(`${this.transvirtualRoute}`, payload)
  }

  public deleteAccounts() {
    return this.client
      .delete<ReturnMessage>(`${this.transvirtualRoute}/*`)
  }

  public retryRequest(payload){
    return this.client
    .put<ReturnMessage>(`${this.transvirtualLogRoute}/${payload.id}`, payload)
  }
}
